export default __webpack_public_path__ + "static/media/trash.7343370e.svg";